


























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

interface TemplateConfig {
    id: number;
    subject: string;
    body: string;
}

@Component
export default class StatementNotificationTemplateModal extends Vue {
    @Prop({ default: false }) value!: boolean

    formValid = false
    loading = false
    saving = false

    form: { subject: string; body: string } = {
        subject: '',
        body: ''
    }

    rules = {
        required: [(v: string) => !!v || 'This field is required']
    }

    get visible () { return this.value }
    set visible (val: boolean) { this.$emit('input', val) }

    @Watch('value')
    async onVisibleChange (val: boolean) {
        if (val) await this.load()
    }

    async load () {
        this.reset()
        this.loading = true
        try {
            const resp = await this.$store.dispatch(
                'getStatementNotificationTemplate'
            ) as { status: number; data: TemplateConfig | null }
            if (resp?.status === 200 && resp.data) {
                this.form = { subject: resp.data.subject, body: resp.data.body }
            }
        } finally {
            this.loading = false
        }
    }

    async save () {
        const valid = (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!valid) return

        this.saving = true
        const resp = await this.$store.dispatch('saveStatementNotificationTemplate', {
            subject: this.form.subject,
            body: this.form.body
        }) as { status: number }
        this.saving = false

        if (resp?.status === 200) {
            this.$store.commit('reportSuccess', 'Done Successfully!')
            this.close()
        } else {
            this.$store.commit('reportError', {
                code: resp?.status,
                message: 'Error saving template'
            })
        }
    }

    reset () {
        this.form = { subject: '', body: '' }
        if (this.$refs.form) {
            (this.$refs.form as Vue & { resetValidation: () => void }).resetValidation()
        }
    }

    close () {
        this.reset()
        this.$emit('input', false)
    }
}
